import AbstractRequestTask from "../AbstractRequestTask";
import getAppConfig from "../../../config/appConfig";
import Utils from "../../../utils/Utils";
import {DISABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import DeviceStorage from '../../../components/DeviceStorage/DeviceStorage';

class EpgTask extends AbstractRequestTask {
  constructor(parameters) {
    super();
    this.customParameters = parameters;
  }
  isValid(data)
  {

    if(data.errors) {
        data.body = [];
        data.channels = [];
        data.channelsRender = [];
        return false;
    }

    return data.body?true:false;
  }

  getHeaders() {
    return {};
  }

  getShowErrorModal(){
    return DISABLE_MODAL_RETRIES;
  }

  getParams() {
    const params = super.getParams();
    let now = Utils.now(true);
    //TODO mejor tecnica para este redondeo
    const time = now.toObject();
    time.minutes        -=(time.minutes%15);
    now=now.format('YYYYMMDDHHmmss');
    now=now.substring(0,now.length-4)+(time.minutes=='0'?"00":time.minutes.toString())+"00";

    Object.assign(this.customParameters,{
      event_image: Utils.getToggleFunctionsFromMetadata().event_image_from_epg,
      epg_version: DeviceStorage.getItem('epgVersion') || false,
      soa_version: DeviceStorage.getItem('soaVersion') || false,
    });

    //youbora
    window.youboraParams[14].value = DeviceStorage.getItem('epgVersion') || '';
    //TODO mejor tecnica para este redondeo
    return { ...params, ...this.customParameters, now };
  }

  getUrl() {
    return `${getAppConfig().end_point_middleware}epg`;
  }

  success(data, b) {
    this.resolve(data);
  }
}

export default EpgTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/epg/EpgTask.js